/** Types + row mapper for the reference library feature. */

export type LibraryDocStatus = "processing" | "ready" | "error";

export type LibraryDocument = {
  docId: string;
  title: string;
  filename: string;
  size: number;
  status: LibraryDocStatus;
  errorMessage?: string;
  pageCount?: number;
  chunkCount?: number;
  createdAt: number; // ms epoch
};

export function mapItem(it: any): LibraryDocument {
  // Validate the status against the union: an unknown value is a bug, so it
  // surfaces loudly as an error row instead of rendering as a silent blank.
  const raw = it.status;
  const known = raw === "processing" || raw === "ready" || raw === "error";
  return {
    docId: String(it.doc_id),
    title: String(it.title ?? ""),
    filename: String(it.filename ?? ""),
    size: Number(it.size ?? 0),
    status: known ? (raw as LibraryDocStatus) : "error",
    errorMessage: known ? (it.error_message ?? undefined) : `unknown status: ${String(raw)}`,
    pageCount: it.page_count != null ? Number(it.page_count) : undefined,
    chunkCount: it.chunk_count != null ? Number(it.chunk_count) : undefined,
    createdAt: Number(it.created_at_ms ?? 0),
  };
}
